export const WORKSHEET_LOAD = 'WORKSHEET_LOAD';
export const WORKSHEET_LOAD_REQUESTED = 'WORKSHEET_LOAD_REQUESTED';
export const WORKSHEET_LOAD_SUCCEEDED = 'WORKSHEET_LOAD_SUCCEEDED';
export const WORKSHEET_LOAD_FAILED = 'WORKSHEET_LOAD_FAILED';
export const WORKSHEET_SET = 'WORKSHEET_SET';

export const WORKSHEET_TYPE_CROP_SPRAY = 'CROP_SPRAY';
export const WORKSHEET_TYPE_WEED_SPRAY = 'WEED_SPRAY';
export const WORKSHEET_TYPE_FERTILIZER = 'FERTILIZER';
